import { Outlet, useLocation } from 'react-router-dom';
import { RequireAuth } from './Auth';
import AdvancedPullToRefresh from '../components/AdvancedPullToRefresh';
import Loader from '../components/Loader';
import React, { useState, useEffect } from 'react';

export default function PrivateOutlet() {
    const isMobile = window.innerWidth <= 768;
    const { pathname } = useLocation();
    const [refreshSignal, setRefreshSignal] = useState(0);
    const [globalLoading, setGlobalLoading] = useState(false);

    // Fix iOS PWA standalone rendering bug on back navigation
    // iOS doesn't repaint elements above the fold after navigate(-1).
    // A tiny scroll nudge after render forces the repaint.
    useEffect(() => {
        const timer = setTimeout(() => {
            window.scrollTo(0, 1);
            requestAnimationFrame(() => {
                window.scrollTo(0, 0);
            });
        }, 100);
        return () => clearTimeout(timer);
    }, [pathname]);

    const handleRefresh = () => {
        return new Promise((resolve) => {
            setRefreshSignal((prev) => prev + 1);
            resolve();
        });
    };

    const handleLoadingStateChange = (isLoading) => {
        setGlobalLoading(isLoading);
    };

    return (
        <RequireAuth>
            {globalLoading && <Loader loading={true} />}
            {isMobile ? (
                <AdvancedPullToRefresh
                    onRefresh={handleRefresh}
                    onLoadingStateChange={handleLoadingStateChange}
                >
                    <Outlet context={{ refreshSignal }} />
                </AdvancedPullToRefresh>
            ) : (
                <Outlet context={{ refreshSignal }} />
            )}
        </RequireAuth>
    );
}
